import DatePicker from 'react-multi-date-picker';
import Toolbar from "react-multi-date-picker/plugins/toolbar"

function DateRangePicker({ setDateRange }) {
    return (
        <div className="date-range-picker-wrapper">
            <DatePicker
                range
                rangeHover
                onOpen={() => true}
                placeholder="Start Date ~ End Date"
                inputClass="date-range-input"
                containerClassName="date-range-container"
                onChange={setDateRange}
                maxDate={new Date()}
                plugins={[
                    <Toolbar position="bottom" />
                ]}
            />
        </div>
    )
}

export default DateRangePicker